import { render, staticRenderFns } from "./PromotIndexView.vue?vue&type=template&id=27075f2e&scoped=true"
import script from "./PromotIndexView.vue?vue&type=script&lang=js"
export * from "./PromotIndexView.vue?vue&type=script&lang=js"
import style0 from "./PromotIndexView.vue?vue&type=style&index=0&id=27075f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27075f2e",
  null
  
)

export default component.exports